// extracted by mini-css-extract-plugin
export default {"label":"measurementInput_label__wS1xI","measureTextField":"measurementInput_measureTextField__swwMs"};